import { MICROSERVICES, SOURCES } from '../constants/services/servicesConstants';
import { ERROR_LEVELS, ERROR_TYPES } from '../utils/errors/errorsUtils';

class GlobalErrorLogger {
  constructor(type) {
    this.baseHeaders = {
      'Content-Type': 'application/json',
      'x-app-platform': MICROSERVICES.WEBAPP,
      'x-app-source': SOURCES.WEBAPP,
    };
    this.type = type;
  }

  logError(orderId = null, error, metadata = {},isTriggerCrashReport = false) {
    try {
      const response = fetch(`${process.env.REACT_APP_BACKEND_URL}/errors/log/${this.type}`, {
        method: 'POST',
        headers: this.baseHeaders,
        body: JSON.stringify({
          orderId,
          error: error,
          type: this.type,
          metadata: metadata,
          timestamp: new Date().toISOString(),
          isTriggerCrashReport: isTriggerCrashReport,
        })
      });

      response.catch(fetchError => {
        console.info('Failed to log error to backend (this is expected and safe):', fetchError.message);
      });

    } catch (error) {
      console.info('Error preparing error log:', error.message);
    }
  }
}


class NetworkErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.NETWORK);
  }
}

class RuntimeErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.RUNTIME);
  }
}

class ValidationErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.VALIDATION);
  }
}

class ResourceErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.RESOURCE);
  }
}

class StorageErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.STORAGE);
  }
}

class MediaErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.MEDIA);
  }
}

class BrowserErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.BROWSER);
  }
}

class PerformanceErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.PERFORMANCE);
  }
}

class ConfigurationErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.CONFIGURATION);
  }
}

class UnknownErrorLogger extends GlobalErrorLogger {
  constructor() {
    super(ERROR_TYPES.UNKNOWN);
  }
}


class ErrorLoggerFactory {
  static createLogger(type) {
    switch (type) {
      case ERROR_TYPES.NETWORK:
        return new NetworkErrorLogger();
      case ERROR_TYPES.RUNTIME:
        return new RuntimeErrorLogger();
      case ERROR_TYPES.VALIDATION:
        return new ValidationErrorLogger();
      case ERROR_TYPES.RESOURCE:
        return new ResourceErrorLogger();
      case ERROR_TYPES.STORAGE:
        return new StorageErrorLogger();
      case ERROR_TYPES.MEDIA:
        return new MediaErrorLogger();
      case ERROR_TYPES.BROWSER:
        return new BrowserErrorLogger();
      case ERROR_TYPES.PERFORMANCE:
        return new PerformanceErrorLogger();
      case ERROR_TYPES.CONFIGURATION:
        return new ConfigurationErrorLogger();
      case ERROR_TYPES.UNKNOWN:
        return new UnknownErrorLogger();
    }
  }

  static logError(orderId = null, error, type, metadata = {},isTriggerCrashReport = false) {
    console.log('metadata', metadata);
    const logger = this.createLogger(type);
    return logger.logError(orderId, error, metadata,isTriggerCrashReport);
  }
}

export {
  ErrorLoggerFactory,
};